"use client";

import { Button } from "@/components/ui/button";
import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
} from "@tabler/icons-react";
import {
  SidebarMenu,
  useConversationsMenu,
} from "../conversations-layout-provider";
import { ConversationsMenuContent } from "./conversations-menu-content";

export function ConversationsMenu() {
  const { state, close } = useConversationsMenu();

  return (
    <SidebarMenu state={state} breakpoint="lg" position="left" action={close}>
      <ConversationsMenuContent />
    </SidebarMenu>
  );
}

export function ToggleConversationsMenu() {
  const { toggle, state } = useConversationsMenu();

  return (
    <Button
      variant="ghost"
      size="md"
      onClick={toggle}
      icon={
        state === "open" ? (
          <IconLayoutSidebarLeftCollapse className="size-5" />
        ) : (
          <IconLayoutSidebarLeftExpand className="size-5" />
        )
      }
      tooltip={
        state === "open"
          ? "Close Conversations Menu"
          : "Open Conversations Menu"
      }
      aria-label={
        state === "open"
          ? "Close Conversations Menu"
          : "Open Conversations Menu"
      }
    />
  );
}
